import { AuthProvider } from './contexts/AuthContext'
import CoreRoutes from './routes/CoreRoutes'
import './index.css'
// import { Toaster as Sonner } from './components/ui/sonner';
import { LoadingContextProvider } from './store/LoadingContextProvider';
import { LoadingSpin } from './components/ui/LoadingSpin';
import { TooltipProvider } from './components/ui/tooltip';
import { Toaster as Sonner } from './components/ui/sonner';
// import { Toaster } from './components/ui/toaster';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ContactButton from './components/contactButton';

const App = () => {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <LoadingContextProvider>
        <TooltipProvider>
          <AuthProvider>
            <CoreRoutes />
            <LoadingSpin />
            <Sonner />
            <ContactButton />
            {/* <Sonner /> */}
          </AuthProvider>
        </TooltipProvider>
      </LoadingContextProvider>
    </GoogleOAuthProvider>
  )
}

export default App